import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useDocumentsStore } from "@/stores/documents";
import InnFilter from "@/components/general/Filter.vue";
import InnSelect from "@/components/ds/select/Select.vue";
import InnInput from "@/components/ds/input/Input.vue";
import { getYearList } from "@/tools/date";
import { useCompanyStore } from "@/stores/company";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentsFilter',
  setup(__props) {

const documentsStore = useDocumentsStore();
const companyStore = useCompanyStore();

const doctypes = [
    {
        key: "invoice",
        label: "Factuur",
    },
    {
        key: "quotation",
        label: "Offerte",
    },
    {
        key: "*",
        label: "Alle",
    },
];

const paidStatuses = [
    {
        key: true,
        label: "Betaald",
    },
    {
        key: false,
        label: "Niet betaald",
    },
    {
        key: "*",
        label: "Alle",
    },
];

const years = [
    "*",
    ...getYearList(
        companyStore.company ? companyStore.company.startingYear : 2020
    ),
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnFilter, null, {
    default: _withCtx(() => [
      _createVNode(InnInput, {
        modelValue: _unref(documentsStore).search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(documentsStore).search) = $event)),
        placeholder: "Zoeken..."
      }, null, 8, ["modelValue"]),
      _createVNode(InnSelect, {
        items: doctypes,
        modelValue: _unref(documentsStore).doctype,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(documentsStore).doctype) = $event)),
        "item-title": "label",
        "item-value": "key"
      }, null, 8, ["modelValue"]),
      _createVNode(InnSelect, {
        items: years,
        modelValue: _unref(documentsStore).year,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(documentsStore).year) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(InnSelect, {
        items: paidStatuses,
        modelValue: _unref(documentsStore).paid,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(documentsStore).paid) = $event)),
        "item-title": "label",
        "item-value": "key"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})